import { render, staticRenderFns } from "./StaffStatsCard.vue?vue&type=template&id=687c17bc&scoped=true&"
import script from "./StaffStatsCard.vue?vue&type=script&lang=js&"
export * from "./StaffStatsCard.vue?vue&type=script&lang=js&"
import style0 from "./StaffStatsCard.vue?vue&type=style&index=0&id=687c17bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687c17bc",
  null
  
)

export default component.exports